import AppText from 'voxguru-v1/components/Typography/AppText';
import AppFlex from 'voxguru-v1/components/chakraLayoutOverrides/AppFlex';
import AppBox from 'voxguru-v1/components/chakraLayoutOverrides/AppBox';
import { Image, useDisclosure, useBreakpointValue } from '@chakra-ui/react';
import { CopyContentIcon } from 'voxguru-v1/assets';
import { fontWeights } from 'voxguru-v1/theme/fonts';
import StudentProgramDetailDrawable from 'voxguru-v1/components/StudentProgramDetailDrawable/StudentProgramDetailDrawable';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { GET_STUDENT_LIVE_CLASS_DETAIL_DATA } from 'voxguru-v1/api/urls';
import makeGetRequest from 'voxguru-v1/api/utils/makeGetRequest';
import AppLoader from 'voxguru-v1/components/AppLoader/AppLoader';
import { useEffect, useState } from 'react';
import getFormattedDate from 'voxguru-v1/utils/getFormattedData';
import {
  MAKE_STUDENT_PROGRAM_DETAIL,
  MAKE_STUDENT_PROGRAM_DETAIL_CONTENT,
} from 'voxguru-v1/navigation//routes';

function StudentProgramContent() {
  const [activeModule, setActiveModule] = useState(null);
  const {
    isOpen: programDrawableIsOpen,
    onOpen: programDrawableOnOpen,
    onClose: programDrawableOnClose,
  } = useDisclosure();

  const navigate = useNavigate();
  const { programSlug, moduleSlug } = useParams();

  const { data, isLoading } = useQuery(
    GET_STUDENT_LIVE_CLASS_DETAIL_DATA(programSlug),
    () => makeGetRequest(GET_STUDENT_LIVE_CLASS_DETAIL_DATA(programSlug)),
  );

  const isMobile = useBreakpointValue({ base: true, sm: false });

  const handleNavigateDrawable = (module) => {
    navigate(
      MAKE_STUDENT_PROGRAM_DETAIL_CONTENT(programSlug, module.module.id),
    );
  };
  const handleDrawableOpen = (module) => {
    programDrawableOnOpen();
    setActiveModule(module.module.id);
  };

  const handleDrawableClose = () => {
    navigate(MAKE_STUDENT_PROGRAM_DETAIL(programSlug));
    programDrawableOnClose();
  };

  useEffect(() => {
    if (data && moduleSlug) {
      data.data.enabled_modules.some((moduleData) => {
        if (moduleData.module.id === moduleSlug) {
          handleDrawableOpen(moduleData);
          return true;
        }
        return false;
      });
    }

    if (!moduleSlug) {
      programDrawableOnClose();
    }
  }, [moduleSlug, data]);

  return (
    <AppBox>
      <AppLoader isLoading={isLoading}>
        {!isLoading && (
          <>
            {/* Listing */}
            <AppText title="Unlocked Modules" variant="headerLargeLight" />

            {data.data.enabled_modules.map((enabledModulesData, index) => (
              <AppFlex
                variant="moduleListingCard"
                customStyles={{ justifyContent: 'space-between' }}
                onClick={() => {
                  // eslint-disable-next-line no-unused-expressions
                  isMobile && handleNavigateDrawable(enabledModulesData);
                }}
              >
                <AppBox>
                  <AppFlex>
                    <AppText
                      title={`${data.data.live_class.identity}`}
                      variant="orangeXXS"
                    />
                    <AppText title="/" size="xxs" customStyles={{ mx: 1 }} />
                    <AppText title={`MODULE ${index + 1}`} variant="lightXXS" />
                  </AppFlex>
                  <AppText
                    title={enabledModulesData.module.identity}
                    size="sm"
                    onClick={() => handleNavigateDrawable(enabledModulesData)}
                    customStyles={{
                      cursor: 'pointer',
                      width: 'fit-content',
                    }}
                  />
                  <AppText
                    title={`Unlocked on ${getFormattedDate(
                      enabledModulesData.created,
                    )}`}
                    variant="lightXXS"
                    customStyles={{
                      fontWeight: fontWeights.normal,
                    }}
                  />
                </AppBox>

                <AppFlex
                  customStyles={{ alignItems: 'center', cursor: 'pointer' }}
                  onClick={() => {
                    handleNavigateDrawable(enabledModulesData);
                  }}
                >
                  <Image src={CopyContentIcon} mr={2} alt="" />
                  <AppText
                    title={enabledModulesData.content_count}
                    variant="lightXS"
                  />
                </AppFlex>
              </AppFlex>
            ))}

            {activeModule && (
              <StudentProgramDetailDrawable
                moduleName={`${data.data.live_class.identity}`}
                isOpen={programDrawableIsOpen}
                onClose={handleDrawableClose}
                activeModule={activeModule}
              />
            )}
          </>
        )}
      </AppLoader>
    </AppBox>
  );
}

export default StudentProgramContent;
